import { createFileRoute, redirect } from '@tanstack/react-router'

import { AuthScreen, isAuthenticated, RecoveryForm } from '#/modules/auth'

function RecoveryPage() {
  return (
    <AuthScreen>
      <RecoveryForm />
    </AuthScreen>
  )
}

export const Route = createFileRoute('/login_/recovery')({
  beforeLoad: () => {
    if (isAuthenticated()) {
      throw redirect({ to: '/' })
    }
  },
  component: RecoveryPage,
})
